<template>
	<div class="courier">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>
					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-6 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2">
										<h4>Kurir</h4>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
											<li class="breadcrumb-item active" aria-current="page"><a href="javascript:;">Kurir</a></li>
										</ol>
									</nav>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-md-12 mb-2">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-6 col-md-6 font-size-sm-11">
														<p>Data Kurir</p>
													</div>
													<!-- <div class="col-6 col-md-6 mt-n1 pr-4">
														<button class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right" data-toggle="modal" data-target="#modalChangeProfile"><img src="assets/icon/excel.png" class="img-fluid pr-2">Export Data</button>
													</div> -->
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-show="courier.length == 0 ">
								<div class="col-12 col-lg-4 col-md-6 mb-2" v-for="(index) in 9" :key="index">
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pb-3 pl-4">
											<div class="col-12 p-0">
												<vcl :width='400' :height='50'>
													<rect x="5" y="10" rx="3" ry="3" width="45" height="28" />  
													<rect x="90" y="10" rx="2" ry="2" width="60" height="15" />  
													<rect x="90" y="35" rx="2" ry="2" width="150" height="15" />  
													<rect x="310" y="12" rx="15" ry="15" width="65" height="28" />
												</vcl>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-if="courier.length > 0 ">
								<div class="col-12 col-lg-4 col-md-6 mb-2" v-for="(cour,index) in courier" :key="index">
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pb-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-2 col-md-2 p-0 ml-2 mt-1">
														<div><img :src="'assets/kurir/'+cour.code+'.png'" width="50px;" class="img-fluid d-flex"></div>
													</div>
													<div class="col-6 col-md-6 pl-0 pr-0 ml-3">
														<div class="text-purple font-size-11">{{cour.code.toUpperCase()}}</div>
														<div class="font-size-9">{{cour.name}}</div>
													</div>
													<div class="col-3 col-md-3 pt-2 pl-0">
														<div class="float-right pr-3 mt-1">
															<label class="switch">
																<input type="checkbox" :checked="cour.selected==1" @input="editCour(cour)">
																<span class="slider round"></span>
															</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	computed:{
		...mapState('courierList', ['courier', 'selectedCourier']),
	},
	methods:{
		...mapActions('courierList', ['getCourier', 'updateCourier']),
		...mapMutations('courierList', ['selectCourier']),

		editCour(cour){
			if(cour.selected==1){
				this.removeCour(cour)
			} else{
				this.selectedCourier.push(cour)
			}
			this.selectCourier(this.selectedCourier)
			this.updateCourier(this.selectedCourier)
		},
		removeCour(cour){
			for( var i = 0; i < this.selectedCourier.length; i++){ 
				if ( this.selectedCourier[i] === cour) {
					this.selectedCourier.splice(i, 1); 
				}
			}
		}
	},
	created(){
		this.getCourier();
		this.$store.dispatch('setPageTitle', `Kurir`);
	}
}
</script>